export default "__VITE_ASSET__jqAJlTAF__"